import { render } from "./Food-add.vue?vue&type=template&id=1a25b6ab&scoped=true"
import script from "./Food-add.vue?vue&type=script&lang=js"
export * from "./Food-add.vue?vue&type=script&lang=js"

import "./Food-add.vue?vue&type=style&index=0&id=1a25b6ab&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a25b6ab"]])

export default __exports__